module.exports = __webpack_public_path__ + "img/xlsx.4ace3429.svg";